import { useState } from 'react';

import { Box, Center, Image, ImageProps, Skeleton } from '@mantine/core';

import { File } from 'models';
import { CollateralHelpers } from 'helpers/CollateralHelpers';

import { FileIcon } from 'components/file-icon/FileIcon';

import cx from './CollateralPage.module.scss';

const CollateralPage = ({
    file,
    page = 1,
    width,
    alt,
    iconSize = 48,
    ...props
}: {
    file: File;
    page?: number;
    width: number;
    alt: string;
    iconSize?: number;
} & Omit<ImageProps, 'src' | 'alt'>) => {
    const src = CollateralHelpers.pageSrc(file, page, width);

    // Tracked per src because pages reuse this component when they switch to another file
    const [failedSrc, setFailedSrc] = useState<string | null>(null);
    const [loadedSrc, setLoadedSrc] = useState<string | null>(null);
    const loaded = loadedSrc === src;

    if (failedSrc === src || !CollateralHelpers.hasPreview(file)) {
        return (
            <Center className={cx.fallback} c="gray.5">
                <FileIcon mimeType={file.mimeType} size={iconSize} />
            </Center>
        );
    }

    return (
        <Box className={cx.root} data-loaded={loaded || undefined}>
            {!loaded && <Skeleton className={cx.skeleton} radius={0} />}
            <Image
                src={src}
                alt={alt}
                loading="lazy"
                decoding="async"
                onLoad={() => setLoadedSrc(src)}
                onError={() => setFailedSrc(src)}
                className={cx.page}
                {...props}
            />
        </Box>
    );
};

export { CollateralPage };
